let loading = false;

export default {
  loadEcharts(tag) {
    return new Promise((resolve, reject) => {
      if (!window.echarts && !window.$echarts) {
        /****观察者模式动态加载echarts script 标签，防止多次加载script   start******************/
        dsf.emit.$on("loadCharts", () => {
          window.$echarts = window.echarts;
          //加载完成
          resolve();
        }, tag);
        if (!loading) {
          loading = true;
          dsf.http
            .importFiles([dsf.url.getWebPath('$/js/libs/echarts/echarts.min.js')])
            .then(() => {
              dsf.emit.$emit('loadCharts');
            })
            .catch((err) => {
              dsf.layer.message('加载echarts文件报错', false)
              reject(err);
            });
        }
        return;
      }
      //加载完成
      resolve();
    })
  }
}